























import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { ModuleNames } from '@/store/module-names'
import { ActionNames as SiteActionNames } from '@/store/modules/site/keys'
import { GetterNames as SiteGetterNames } from '@/store/modules/site/keys'
import { FlatSite } from '@/store/modules/site/getters'

export default {
  props: {
    stageIndex: {
      type: Number,
      required: true,
    },
    site: {
      type: Object,
      required: false,
      default: null,
    },
    isSavingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isInitialLoading: true,

      pccOrg: null,
      pccFacId: null,
      patientMonitoringEnabled: false,
      syncPatientsFromEmr: false,
    }
  },

  computed: {
    ...mapGetters(ModuleNames.site, {
      authorizedSites: `${SiteGetterNames.sites}`,
    }),
    authorizedSitesSorted() {
      return this.authorizedSites.slice().sort((a, b) => {
        return a.siteName.localeCompare(b.siteName)
      })
    },
    selectedSite: {
      get() {
        return this.site
      },
      set(value) {
        this.$emit('update:site', value)
      },
    },
  },

  async mounted(): Promise<void> {
    await Promise.all([this[SiteActionNames.getSites]()])
    this.isInitialLoading = false
    let s = this.sites
    this.emitValidStatus()
  },

  beforeUpdate: async function(): Promise<void> {
    this.emitValidStatus()
  },
  methods: {
    ...mapActions(ModuleNames.site, [SiteActionNames.getSites]),

    siteName(val: any): string {
      return `${val.siteName}`
    },

    emitValidStatus() {
      this.$emit('stageIsValid', {
        stageIndex: this.stageIndex,
        isValid: this.selectedSite!!,
      })
    },

    // emitSite() {
    //   this.$emit('update:site', this.site)
    //   // this.$emit('selectSite', this.selectedSite)
    // },

    siteSelected(e) {
      this.$nextTick(() => {
        this.pccOrg = this.selectedSite.pccOrg
        this.pccFacId = this.selectedSite.pccFacId
        this.patientMonitoringEnabled = this.selectedSite.patientMonitoringEnabled
        this.syncPatientsFromEmr = this.selectedSite.syncPatientsFromEmr
        // this.emitSite()
        this.emitValidStatus()
      })
    },

    pccOrgInput(e) {
      console.log(e)
    },
    pccFacIdInput(e) {
      console.log(e)
    },

    async saveSiteDetails() {
      console.log('saving site details')
      this.selectedSite.pccOrg = this.pccOrg
      this.selectedSite.pccFacId = this.pccFacId
      this.selectedSite.patientMonitoringEnabled = this.patientMonitoringEnabled
      this.selectedSite.syncPatientsFromEmr = this.syncPatientsFromEmr
      this.$emit('uploadSite', this.selectedSite)
    },
  },
}
